import React, { useContext, useEffect, useState } from "react";
import {
    currentWeekStartDate,
    previousWeekStartDate,
} from "features/timesheet/timesheet-grid/SubmitTimesheet";
import { getLocalTimeZone, today } from "@internationalized/date";

import { COLOR_VALUES } from "shared/config/colors";
import HStack from "shared/components/layout/stack/HStack";
import SubmitTimesheetContext from "features/timesheet/contexts/SubmitTimesheetContext";
import TertiaryButton from "shared/components/inputs/button/TertiaryButton";
import Text from "shared/components/data-display/text/Text";
import VStack from "shared/components/layout/stack/VStack";
import WeekNavigatorContext from "shared/contexts/WeekNavigatorContext";
import env from "react-dotenv";
import { mediaQueries } from "shared/config/breakpoints";
import styled from "styled-components";

const StyledText = styled(Text)`
    font-variation-settings: "opsz" 12;
    font-weight: 425;
    padding-top: 4.63px;
    
    ${mediaQueries.small} {
        font-size: 0.75rem;
        line-height: 1.4;
        padding-top: 4px;
    }
`;

const StyledCopyText = styled(Text)`
    padding-top: 4.63px;
    
    ${mediaQueries.small} {
        font-size: 0.75rem;
        padding-top: 4px;
    }
`;

const StyledWrapper = styled(HStack)`
    .textMassage {
        visibility: hidden;
        font-weight: 425;
    }
    &:not(:disabled) {
        &:hover {
            button {
                background: ${COLOR_VALUES.White};
            }
        }
    }
    &:hover {
        .textMassage {
            visibility: visible;
        }
    }
    
    ${mediaQueries.small} {
        flex-direction: column;
        align-items: flex-start;
        gap: 4px;
        
        .textMassage {
            visibility: visible;
        }
        
        button {
            font-size: 0.75rem;
            padding: 6px 12px;
        }
    }
`;

const LockedTimesheetFooter = () => {
    const { selectedTimesheetStartDate } = useContext(WeekNavigatorContext);
    const { selectedDateTimesheetStatus } = useContext(SubmitTimesheetContext);

    const [copy, setCopy] = useState("Copy");

    const copyToClipboard = (mail) => {
        if (navigator?.clipboard) {
            navigator.clipboard.writeText(mail);
            setCopy("Copied");
        }
    };

    let fromDateVal = selectedTimesheetStartDate ?? today(getLocalTimeZone());
    let formatFromDateVal = `${fromDateVal.year}-${fromDateVal.month}-${fromDateVal.day}`;

    useEffect(() => {
        setCopy("Copy");
    }, [selectedTimesheetStartDate]);

    return (
        <>
            {previousWeekStartDate !== formatFromDateVal &&
                currentWeekStartDate !== formatFromDateVal &&
                new Date(currentWeekStartDate) > new Date(formatFromDateVal) &&
                selectedDateTimesheetStatus &&
                    (
                        <VStack spacing="Two">
                            <HStack spacing="Zero_25">
                                <StyledText variant="Body_2_1" color="Gray_2">
                                    This week&#39;s timesheet is locked and may not
                                    be edited. If you need to reopen the
                                    timesheet&#44; please contact
                                </StyledText>
                                <StyledWrapper spacing="Zero_25">
                                    <TertiaryButton
                                        trailingIcon="mail"
                                        label="Reporter Team"
                                        onClick={() => {
                                            copyToClipboard(env.REPORTER_SUPPORT_EMAIL);
                                        }}
                                    />
                                    <StyledCopyText
                                        variant="Body_2_1"
                                        className="textMassage"
                                        color="Gray_2"
                                    >
                                        {copy}
                                    </StyledCopyText>
                                </StyledWrapper>
                            </HStack>
                        </VStack>
                    )}
        </>
    );
};

export default LockedTimesheetFooter;
